import React, {useState} from 'react';

import './NumberKeyboard.css';
import {Button, Grid} from "@mui/material";

type NumberKeyboardProps = {
    onChange: (value: string) => void;
};

const NumberKeyboard: React.FC<NumberKeyboardProps> = (props) => {

    const [number, setNumber] = useState('');

    const handleChange = (value: string) => {
        setNumber(value);
        props.onChange(value);
    }

    const clickNum = (num: string) => {
        let newNumber = number;
        if (num === 'D') {
            if (newNumber.length > 0) {
                newNumber = newNumber.substring(0, newNumber.length - 1);
            }
        } else if (num === 'C') {
            newNumber = '';
        } else {
            newNumber += num;
        }

        handleChange(newNumber);
    }

    return (
        <div className={'visit-code-input-form'}>
            <Grid container spacing={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center">
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('1')}>1</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('2')}>2</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('3')}>3</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('4')}>4</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('5')}>5</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('6')}>6</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('7')}>7</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('8')}>8</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('9')}>9</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('C')}>C</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('0')}>0</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button variant="outlined" fullWidth={true} onClick={() => clickNum('D')}>DEL</Button>
                </Grid>
            </Grid>
        </div>
    );
}

export default NumberKeyboard;